<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="showList">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">
            Master Area/Wilayah
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Close
              </button>
            </div>
          </div>
          <b-table
            class="mb-0"
            ref="table"
            outlined
            responsive
            hover
            small
            style="font-size:smaller;"
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            @row-clicked="rowClicked"
          >
        <template v-slot:cell(area_member)="data">
                <span v-if="(data.item.area_member)"><b-link @click.stop="showAreaMember(data.item)">{{data.item.area_member}}</b-link></span>
                <span v-else ><b-link @click.stop="showAreaMember(data.item)">Edit sub/Member</b-link></span>
        </template>

            <template v-slot:cell(action)="data">
              <div class="text-center">
                <a href="javascript:void(0)" @click.stop="edit(data.item)">
                  <i class="fa fa-pencil"></i>
                </a>
                |
                <a
                  href="javascript:void(0)"
                  class="text-danger"
                  @click.stop="deleteConfirm(data.item)"
                >
                  <i class="fa fa-trash"></i>
                </a>
              </div>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="6">
              <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to
                <span
                  v-if="((tblData.page * tblData.limit)>tblData.total)"
                >{{tblData.total}}</span>
                <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
              </div>
            </b-col>
            <b-col cols="6">
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Area/Wilayah - Add/Edit Form</div>
          <b-input-group >
            <b-input-group-prepend class="mr-4">
              <label>Area/Wilayah</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdata.area_name" :state="!$v.frmdata.area_name.$error"></b-form-input>
          </b-input-group>

          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()">
              <i class="fa fa-close"></i> Close Form
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

      <b-modal v-model="areaMemberShow" header-bg-variant="primary"  title="Area/Wilayah Member" size="md" :centered="true" :hide-footer="true">
            <b-input-group>
                <b-input-group-prepend><span class="p-2">Area</span></b-input-group-prepend>
                <b-form-input v-model="model.area_name" readonly></b-form-input>
                <b-input-group-append>
                    <b-btn text="Button"  @click="lkuKoranKotaShow=true" class="ml-2">
                      <i class="fa fa-plus"></i> Kota sbg member
                    </b-btn>
                </b-input-group-append>
              </b-input-group>

            <b-table
              class="mb-1"
              ref="tblMember"
            small
            style="font-size:smaller;"
              responsive
              striped 
              hover
              :items="areaMember.list"
              :fields="fields"
              :current-page="areaMember.page"
              :per-page="areaMember.limit"
              :sort-by.sync="areaMember.sortBy"
              :sort-desc.sync="areaMember.sortDesc" 
              :key="areaMember.page"
            >
            <template v-slot:cell(action)="data">
              <div class="text-center">
                <a
                  href="javascript:void(0)"
                  class="text-danger"
                  @click.stop="delMember(data.item)"
                >
                  <i class="fa fa-trash"></i> Del
                </a>
              </div>
            </template>
            </b-table>
            <b-row class="mb-0">
                <b-col cols="7">
                  <b-row>
                      <span class="ml-3 pt-1 pr-1">Per page</span>
                      <b-form-select :options="[10, 20, 30, 50, 70, 90]" :plain="true" v-model="areaMember.limit"  size="sm" style="width:60px !important;"/>
                      <div class="pl-1 pt-1">
                        showing {{(areaMember.page - 1) * areaMember.limit + 1}}
                        to <span v-if="((areaMember.page * areaMember.limit)>areaMember.total)">{{areaMember.total}}</span> <span v-else>{{areaMember.page * areaMember.limit}}</span>
                        of {{areaMember.total}} 
                      </div>        
                  </b-row>
                </b-col>
                <b-col cols="5">            
                  <b-pagination
                    align="right"
                    :total-rows="areaMember.total"
                    :per-page="areaMember.limit"
                    v-model="areaMember.page"
                  ></b-pagination>
                </b-col>
              </b-row>        
      </b-modal>
      <b-modal v-model="lkuKoranKotaShow" size="lg" :hide-footer="true" title="List of Kota Layanan" :centered="true">
        <lku-korankota @click="onSelectKotae" ></lku-korankota>
      </b-modal>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>

  </div>
</template>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import lkuKorankota from "../lookup/lkuKoranKota";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuKorankota},
  mixins: [validationMixin],
  validations: {
    frmdata: {
      area_name: { required },
    }
  },
  data() {
    return {
      lkuKoranKotaShow: false,
      showDelConfirm: false,
      areaMemberShow: false,
      user : this.$store.state.user,
      areaMember:{
        list:[],
        page:1,
        total:0,
        limit: 10,
        sortBy: null,
        sortDesc: false
      },
      showList: true,
      showForm: false,
      frmdata: { area_name: "" },
      model: { area_name: "" },
      tblData: {
        tablename: "koranarea",
        page: 1,
        limit: 10,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      tblFields: [
        {
          key: "area_name",
          label: "Nama Area/Wilayah",
          sortable: true
        },
        {
          key: "area_member",
          label: "Kota sub area",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:60px",
          thClass: "text-center"
        }
      ],
      fields: [
        {
          key: "kota_name",
          label: "Nama Kota",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:60px",
          thClass: "text-center"
        }
      ],

    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    }
  },
  methods: {
    onSelectKotae: async function(_sales) {
      this.model.kota_id = _sales.kota_id;
      this.model.kota_name = _sales.kota_name;
      this.lkuKoranKotaShow = false;
        try {
            await crud.update({
              tablename: "korankota",
              key: _sales.kota_id,
              data: {
                area_id: this.frmdata.area_id,
              }
            });
            const par = {
              tablename: "vwkorankota",page:1,limit: 1000,
              sortBy: this.areaMember.sortBy,
              sortDesc: this.areaMember.sortDesc,
              customQuery: `area_id=${encodeURIComponent(this.model.area_id)}`
            }
            const list = await crud.list(par);
            this.areaMember.total=par.total;
            this.areaMember.list=list;    

        } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }

    },
    delMember: async function(item) {
          let jawaban = false;
          jawaban = await this.$bvModal.msgBoxConfirm(` ${item.kota_name} sbg member Group akan dihapus, lanjutkan?`, {
                    title: 'Please Confirm',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Iya',
                    cancelTitle: 'Tidak',
                    cancelVariant: 'danger',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                  });
          if (jawaban == true) {        
            try {
                await crud.update({
                  tablename: "korankota",
                  key: _sales.kota_id,
                  data: {
                    area_id: '',
                  }
                });
                const par = {
                  tablename: "vwkorankota",page:1,limit: 1000,
                  sortBy: this.areaMember.sortBy,
                  sortDesc: this.areaMember.sortDesc,
                  customQuery: `area_id=${encodeURIComponent(this.model.area_id)}`
                }
                const list = await crud.list(par);
                this.areaMember.total=par.total;
                this.areaMember.list=list;    
            } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
            }
          }   
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.showForm = true;
      this.showList = false;
    },
    edit: async function(data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.idlama = data.area_id;
      this.showForm = true;
      this.showList = false;
    },
    save: async function(callback) {
      if (this.invalidFormdata) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          if (this.frmdata.idlama) {
            await crud.update({
              tablename: "koranarea",
              key: this.frmdata.idlama,
              data: {
                area_name: this.frmdata.area_name,
              }
            });
          } else {
            await crud.insert({
              tablename: "koranarea",
              data: {
                area_name: this.frmdata.area_name,
              }
            });
          }
          this.closeFrm();
          setTimeout(() => {
            this.refresh();
          }, 500);
        } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({ tablename: "koranarea", key: this.model.area_id });
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },

    showAreaMember: async function(record) {
      try {
        this.model = record;
        this.isLoading=true;
        const par = {
          tablename: "vwkorankota",page:1,limit: 1000,
          sortBy: this.areaMember.sortBy,
          sortDesc: this.areaMember.sortDesc,
          customQuery: `area_id=${encodeURIComponent(this.model.area_id)}`
        }
        const list = await crud.list(par);
        this.areaMember.total=par.total;
        this.areaMember.list=list;    

        this.areaMemberShow=true;            
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }                
      }

    },

    close() {
      router.push({name: "koran.home"});
    }
  }
};
</script>
